import React from 'react'

import * as S from './processingCard.styles'

export const ProcessingCard = () => {
    return (
        <S.ProcessingCard>
            <S.Title>
                Defining &quot;cultural fit&quot; in terms of alignment with the company&apos;s values and mission,
                focusing on qualifications and diverse perspectives.
            </S.Title>

            <S.Description>Inclusive Hiring 101</S.Description>
        </S.ProcessingCard>
    )
}
